export { default } from './GlobalSearch';
